import { useEffect } from "react";
import { useDashboardUIActions, useDashboardUIContext } from "@contexts/dashboardUI";
import { useProjectContext } from "@contexts/projects";
import { isPresentationProject } from "@utils/presentationMode";
import { useTitleAnnulments } from "./TitleAnnulmentsContext";
import { hasAnnulments } from "./summary";

// Item "Títulos anulados" do menu de ações da obra (barra do usuário, ícone ⋮): leva quem pode
// editar a incluir o primeiro título quando a obra ainda não tem card. Quem não pode editar, ou
// a obra que já tem o card, não vê o item. `canWrite` só se sabe pela lista da obra, então ela
// é consultada quando o menu abre.
const TitleAnnulmentsMenuItem = () => {
  const { activeProject } = useProjectContext();
  const { showOffcanvas } = useDashboardUIContext();
  const { toggleOffcanvas } = useDashboardUIActions();
  const { data, status, load, openOffcanvas } = useTitleAnnulments();
  const projectId = activeProject?._id;
  const eligible = !!projectId
    && !isPresentationProject(activeProject)
    && !hasAnnulments(activeProject?.titleAnnulments);

  useEffect(() => {
    if (eligible && showOffcanvas && status === "idle") load();
  }, [eligible, showOffcanvas, status, load]);

  if (!eligible || data?.canWrite !== true) return null;
  return (
    <>
      <hr className="divider" />
      <button
        type="button"
        onClick={() => {
          toggleOffcanvas();
          openOffcanvas();
        }}
      >
        <span>Títulos anulados</span>
      </button>
    </>
  );
};

export default TitleAnnulmentsMenuItem;
